/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderVkontakteComOauthOptions
 */
export interface FxIdApplicationPublicDataBuilderVkontakteComOauthOptions {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationPublicDataBuilderVkontakteComOauthOptions
     */
    AppId: number;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderVkontakteComOauthOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions(value: object): value is FxIdApplicationPublicDataBuilderVkontakteComOauthOptions {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderVkontakteComOauthOptions {
    return FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderVkontakteComOauthOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderVkontakteComOauthOptions {
    return FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderVkontakteComOauthOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

